import React from 'react';
import { connect } from 'react-redux';

class Education extends React.Component {

    render() {
        let education = []
        if (typeof this.props.eduList  !== undefined && this.props.eduList.length>0) {
            //Sort it by Id
            this.props.eduList.sort((a, b) => {
                return a.id.localeCompare(b.id);
            });

            education = this.props.eduList.map((edu)=>{
               
                return  <div key = {edu.id} className="c-timeline__item">
                    <div className="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                    <div className="o-content">
                        <div className="o-grid">
                            <div className="o-grid__col-md-12">
                               { /* <div className="c-work__timeframe">
                                    {edu.fromDate} &ndash;  {edu.toDate}
                                 </div>*/ }
                                <h3 className="c-work__heading">
                                    {edu.institute}
                                                    </h3>
                                <h4 className="c-work__title">
                                    {edu.degree}
                                                    </h4>
                                <div className="c-work__location">
                                    
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            });
        }   
        return (

            <section className="o-section  t-section  ">

                <div className="o-section__header-bg  t-section__header"></div>
                <div className="o-section__content-bg  t-section__content"></div>

                <div className="o-container">
                    <div className="o-section__container">

                        <header className="o-section__header  t-section__header">
                            <div className="o-content">
                                <h2 className="o-section__heading">
                                    Education
                                </h2>
                            </div>
                        </header>
                        <div className="o-section__content  t-section__content  u-pt-0">

                            <div className="o-content">
                                <div className="a-education-timeline  c-timeline  t-border-color  o-section__full-top-space">
                                    <div className="c-timeline__end  t-border-color"></div>

                                    {education}

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </section>


        );
    }
}

const mapStateToProps = (state) => {
    return {
        eduList: state.education.educationList
    };
};

export default connect(mapStateToProps)(Education);



// WEBPACK FOOTER //
// ./src/components/Education.js